<footer
  class="w-full p-4 bg-primary_tailwind border-t border-gray-200 shadow md:flex md:items-center md:justify-between md:p-6"
>
  <div
    class="container mx-auto max-w-screen-xl flex flex-col md:flex-row items-center justify-between"
  >
    <span class="text-sm text-white text-center md:text-left"
      >© 2024
      <a href="https://www.epn.edu.ec/" class="hover:underline">Escuela Politécnica Nacional</a>.
      All Rights Reserved.
    </span>
    <ul class="flex flex-wrap items-center justify-center text-sm text-white sm:mt-0">
      <li>
        <a href="#" class="mr-4 hover:underline md:mr-6">Privacy Policy</a>
      </li>
      <li>
        <a href="#" class="mr-4 hover:underline md:mr-6">Terms of Service</a>
      </li>
      <li>
        <a href="#" class="hover:underline">Contact</a>
      </li>
    </ul>
  </div>
</footer>
